import React, { useState } from "react";

// Phosphor-style SVG icons rendered at call time
const getIcon = (id) => {
  const icons = {
    "school-setup": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M243.84 76.19l-112-48a8 8 0 0 0-6.68 0l-112 48a8 8 0 0 0 0 14.62L56 109.76V200a16 16 0 0 0 16 16h112a16 16 0 0 0 16-16v-90.24l24-10.32V200a8 8 0 0 0 16 0v-112a8 8 0 0 0-4.16-7.81zM184 200H72v-82.93l56 24.05 56-24.05zm-56-75L35.13 83.2 128 44.21 220.87 83.2z"/></svg>,
    "classrooms-students": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M117.25 157.92a60 60 0 1 0-66.5 0A95.83 95.83 0 0 0 24.76 174C16 183.74 16 190.89 16 192a8 8 0 0 0 16 0c0-4.29 7.06-17 22.39-26.32a76 76 0 0 1 147.22 0C217 175 224 187.71 224 192a8 8 0 0 0 16 0c0-1.11 0-8.26-8.76-18.08a95.83 95.83 0 0 0-25.99-16.08zM84 112a44 44 0 1 1 44 44 44.05 44.05 0 0 1-44-44z"/></svg>,
    "teachers": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M226.53 56.41l-96-32a8 8 0 0 0-5.06 0l-96 32A8 8 0 0 0 24 64v80a8 8 0 0 0 16 0V75.1l33.59 11.19A88.18 88.18 0 0 0 40 156c0 28.32 14.16 54.53 39.47 73.84a8 8 0 0 0 9.06 0C114 211.16 128 192.31 128 172a55.75 55.75 0 0 0-2.52-16.71L176 138.74V184a8 8 0 0 0 4.36 7.14C182.67 192.22 192 195.81 192 208a8 8 0 0 0 16 0c0-18.48-9.48-28.8-16-33.95V132.58l34.53-11.51A8 8 0 0 0 232 113V64a8 8 0 0 0-5.47-7.59zM128 172c0 14.08-9 27.42-24 38.1C89 199.42 80 186.08 80 172a72.12 72.12 0 0 1 28.15-57.23l16.28 5.43A39.65 39.65 0 0 1 128 140.4V172zM216 107.1l-88 29.33-88-29.33V69.9l88-29.33 88 29.33z"/></svg>,
    "inviting-staff": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M256 136a8 8 0 0 1-8 8h-16v16a8 8 0 0 1-16 0v-16h-16a8 8 0 0 1 0-16h16v-16a8 8 0 0 1 16 0v16h16a8 8 0 0 1 8 8zm-57.87 58.85a8 8 0 0 1-12.26 10.3C175.32 193.54 152.44 184 128 184s-47.32 9.54-57.87 21.15a8 8 0 0 1-12.26-10.3c10.28-12.25 25.05-21.3 42-26.25a60 60 0 1 1 56.26 0c16.95 4.95 31.72 14 42 26.25zM128 168a44 44 0 1 0-44-44 44.05 44.05 0 0 0 44 44z"/></svg>,
    "users": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M244.8 150.4a8 8 0 0 1-11.2-1.6A51.6 51.6 0 0 0 192 128a8 8 0 0 1-7.37-4.89 8 8 0 0 1 1.75-8.78 28 28 0 1 0-38.76 0 8 8 0 0 1-5.63 13.67 8 8 0 0 1-5.63-2.33A44 44 0 0 1 128 56a44 44 0 0 1 29.64 76.67A67.38 67.38 0 0 1 192 144a67.63 67.63 0 0 1 54.4 27.2 8 8 0 0 1-1.6 11.2zM64 144a44 44 0 1 0-44-44 44.05 44.05 0 0 0 44 44zm0-72a28 28 0 1 1-28 28 28 28 0 0 1 28-28zm55.35 80.84A67.3 67.3 0 0 1 128 224a67.3 67.3 0 0 1 8.65-71.16 8 8 0 0 0-12.3-10.22A83.35 83.35 0 0 0 112 200a83 83 0 0 0-96 0 8 8 0 0 0 9.4 12.94A67 67 0 0 1 64 208a67 67 0 0 1 42.6 15.06 8 8 0 0 0 9.4-12.94 83.18 83.18 0 0 0-10.65-8.28A83.14 83.14 0 0 1 128 160z"/></svg>,
    "enrollment": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M213.66 82.34l-56-56A8 8 0 0 0 152 24H56a16 16 0 0 0-16 16v176a16 16 0 0 0 16 16h144a16 16 0 0 0 16-16V88a8 8 0 0 0-2.34-5.66zM160 51.31 188.69 80H160zM200 216H56V40h88v48a8 8 0 0 0 8 8h48zm-40-80a8 8 0 0 1-8 8H96a8 8 0 0 1 0-16h56a8 8 0 0 1 8 8zm0 32a8 8 0 0 1-8 8H96a8 8 0 0 1 0-16h56a8 8 0 0 1 8 8zm-24-96a8 8 0 0 1-8 8H96a8 8 0 0 1 0-16h32a8 8 0 0 1 8 8z"/></svg>,
    "attendance": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0zM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104zm-16 0a88 88 0 1 0-88 88 88.1 88.1 0 0 0 88-88z"/></svg>,
    "coverage": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M208 32H184V24a8 8 0 0 0-16 0v8H88V24a8 8 0 0 0-16 0v8H48A16 16 0 0 0 32 48v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM72 48v8a8 8 0 0 0 16 0v-8h80v8a8 8 0 0 0 16 0v-8h24v32H48V48zm136 160H48V96h160zm-68-76a8 8 0 0 1-8 8h-24v24a8 8 0 0 1-16 0v-24H68a8 8 0 0 1 0-16h24v-24a8 8 0 0 1 16 0v24h24a8 8 0 0 1 8 8z"/></svg>,
    "daily-logs": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M213.66 82.34l-56-56A8 8 0 0 0 152 24H56a16 16 0 0 0-16 16v176a16 16 0 0 0 16 16h144a16 16 0 0 0 16-16V88a8 8 0 0 0-2.34-5.66zM160 51.31 188.69 80H160zM200 216H56V40h88v48a8 8 0 0 0 8 8h48zm-32-80a8 8 0 0 1-8 8H96a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8zm0 32a8 8 0 0 1-8 8H96a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8z"/></svg>,
    "events": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zm64-88a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V72a8 8 0 0 1 16 0v56h48a8 8 0 0 1 8 8z"/></svg>,
    "messages-tickets": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M216 48H40a16 16 0 0 0-16 16v160a15.85 15.85 0 0 0 9.24 14.5A16.13 16.13 0 0 0 40 240a15.89 15.89 0 0 0 10.25-3.78.69.69 0 0 0 .13-.11L82.5 208H216a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zM40 224zm176-32H82.5a16 16 0 0 0-10.3 3.75l-.12.11L40 224V64h176z"/></svg>,
    "parent-portal": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M244.8 150.4a8 8 0 0 1-11.2-1.6A51.6 51.6 0 0 0 192 128a8 8 0 0 1-7.37-4.89 8 8 0 0 1 1.75-8.78 28 28 0 1 0-38.76 0 8 8 0 0 1-5.63 13.67 8 8 0 0 1-5.63-2.33A44 44 0 0 1 128 56a44 44 0 0 1 29.64 76.67A67.38 67.38 0 0 1 192 144a67.63 67.63 0 0 1 54.4 27.2 8 8 0 0 1-1.6 11.2zM64 144a44 44 0 1 0-44-44 44.05 44.05 0 0 0 44 44zm0-72a28 28 0 1 1-28 28 28 28 0 0 1 28-28zm119.6 111.2a8 8 0 0 1-11.2 1.6A99.87 99.87 0 0 0 64 160a99.87 99.87 0 0 0-108.4 24.8 8 8 0 1 1-12.26-10.3A116.43 116.43 0 0 1 0 160a116 116 0 0 1 128 0 116.43 116.43 0 0 1 56.66 14.5 8 8 0 0 1 1.6 11.2 8 8 0 0 1-2.66 1.5z"/></svg>,
    "billing": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M224 80H32A16 16 0 0 0 16 96v128a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zm0 144H32V96h192zM208 40a8 8 0 0 1-8 8H56a8 8 0 0 1 0-16h144a8 8 0 0 1 8 8zm-32-32a8 8 0 0 1-8 8H88a8 8 0 0 1 0-16h80a8 8 0 0 1 8 8zm-16 128a32 32 0 1 1-32-32 32 32 0 0 1 32 32z"/></svg>,
    "reports": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M232 208h-8V104a16 16 0 0 0-16-16h-40V64a16 16 0 0 0-16-16H104a16 16 0 0 0-16 16v24H48a16 16 0 0 0-16 16v104h-8a8 8 0 0 0 0 16h208a8 8 0 0 0 0-16zM104 64h48v24h-48zm-56 40h160v104H48zm80 72a8 8 0 1 0-8-8 8 8 0 0 0 8 8z"/></svg>,
    "audit": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66 77.66l-128 128a8 8 0 0 1-11.32 0l-56-56a8 8 0 0 1 11.32-11.32L96 188.69 218.34 66.34a8 8 0 0 1 11.32 11.32z"/></svg>,
    "school-year": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M208 32H184V24a8 8 0 0 0-16 0v8H88V24a8 8 0 0 0-16 0v8H48A16 16 0 0 0 32 48v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM72 48v8a8 8 0 0 0 16 0v-8h80v8a8 8 0 0 0 16 0v-8h24v32H48V48zm136 160H48V96h160zm-96-88a8 8 0 0 1 8-8h32a8 8 0 0 1 0 16h-32a8 8 0 0 1-8-8zm0 32a8 8 0 0 1 8-8h32a8 8 0 0 1 0 16h-32a8 8 0 0 1-8-8zm-32-32a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm0 32a8 8 0 1 1-8-8 8 8 0 0 1 8 8z"/></svg>,
    "subscription": <svg width="26" height="26" viewBox="0 0 256 256" fill="currentColor"><path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zm40-68a28 28 0 0 1-20 26.8V176a8 8 0 0 1-16 0v-2.2A28 28 0 0 1 100 148a8 8 0 0 1 16 0 12 12 0 1 0 12-12 28 28 0 0 1 0-56 28.06 28.06 0 0 1 20 7.2V84a8 8 0 0 1 16 0v2.2A28 28 0 0 1 156 112a8 8 0 0 1-16 0 12 12 0 1 0-12 12 28 28 0 0 1 40 24z"/></svg>,
  };
  return icons[id] || null;
};

const TOPICS = [
  {
    id: "school-setup",
    title: "School Setup",
    subtitle: "Get your school configured in minutes",
    color: "#E8679A",
    pale: "#FCE4EC",
    steps: [
      {
        title: "Create your account",
        description: "Go to shrewcare.com and click 'Start Free Trial'. Enter your name, email address, and a password of at least 6 characters. You'll receive a confirmation email — click the link inside to activate your account.",
        tip: "Use your school's official email address so staff can identify you easily."
      },
      {
        title: "Enter your school details",
        description: "After confirming your email, you'll be taken to the School Setup wizard. Enter your school name and address on the first screen, then click Next.",
        tip: "Don't worry — you can update all of this later in Settings."
      },
      {
        title: "Add contact & preferences",
        description: "On the second screen, enter your school's phone number, email, the director or principal's name and title, and your timezone. This information appears in reports and communications.",
        tip: "Setting the correct timezone ensures attendance timestamps are accurate."
      },
      {
        title: "Set up billing",
        description: "Click 'Launch My School' to complete setup. You'll be taken to Stripe to enter your payment details. Your 30-day free trial starts immediately — you won't be charged until the trial ends.",
        tip: "Your card is stored securely by Stripe. ShrewCare never stores your card details."
      },
      {
        title: "You're in!",
        description: "Welcome to your dashboard. It will be empty for now — that's normal. Start by adding your classrooms in the next step.",
        tip: "Bookmark shrewcare.com for quick access from any device."
      }
    ]
  },
  {
    id: "classrooms-students",
    title: "Classrooms & Students",
    subtitle: "Set up your rooms and enroll your students",
    color: "#66BB6A",
    pale: "#E8F5E9",
    steps: [
      {
        title: "Create your classrooms",
        description: "Go to Classrooms in the sidebar and click 'Add Classroom'. Give each room a name (e.g. 'Sunflowers', 'Butterflies'), set the age group, capacity, and assign a tuition plan. Click Save.",
        tip: "Create all your classrooms before adding students — you'll assign each student to a room during enrollment."
      },
      {
        title: "Add students one by one",
        description: "Go to Students and click 'Add Student'. Fill in the student's first name, last name, date of birth, and classroom. You must also enter the guardian's name, phone number, and email address.",
        tip: "All guardian fields are required — this ensures parents can be reached and invited to the parent portal."
      },
      {
        title: "Add multiple students at once",
        description: "If you have an existing list, you can import students from a previous school year using the Import feature in Students. Select the source year, choose the students, pick a target classroom, and click Import.",
        tip: "This is the fastest way to set up at the start of a new school year."
      },
      {
        title: "Review enrollment",
        description: "Go to Enrollment to see all students in your pipeline. You can move students through stages — Inquiry, Waitlist, Applied, Accepted, Enrolled, and Withdrawn — by editing their enrollment record.",
        tip: "Use the Enrollment page to track prospective students who haven't been formally enrolled yet."
      }
    ]
  },
  {
    id: "teachers",
    title: "Teachers",
    subtitle: "Manage your teaching staff and substitutes",
    color: "#3B82C4",
    pale: "#DBEAFE",
    steps: [
      {
        title: "Add a teacher",
        description: "Go to Teachers in the sidebar and click 'Add Teacher'. Enter their name, email, phone number, and assign them to a classroom. You can also mark them as a substitute teacher using the 'Is Substitute' toggle.",
        tip: "Regular teachers are assigned to a permanent classroom. Substitutes are unassigned and available for coverage."
      },
      {
        title: "Edit teacher details",
        description: "Click on any teacher's card to expand their profile. You can update their name, contact info, classroom assignment, and status. Changes are saved automatically.",
        tip: "Keep teacher phone numbers up to date — they're used when arranging last-minute coverage."
      },
      {
        title: "Teacher status and availability",
        description: "Each teacher has a status visible on the dashboard — Present, Called Out, or On Leave. These statuses are set through the Attendance page each day and reset automatically the following morning.",
        tip: "Teachers marked as Called Out will automatically appear in the Coverage page so you can assign a substitute."
      },
      {
        title: "Remove a teacher",
        description: "To remove a teacher, click their card and select Delete. This removes them from your school's roster but does not delete their user account. They will no longer have access to your school's data.",
        tip: "If a teacher is leaving temporarily (e.g. maternity leave), consider using the On Leave status instead of deleting them."
      }
    ]
  },
  {
    id: "inviting-staff",
    title: "Inviting Staff",
    subtitle: "Bring your team onto the platform",
    color: "#E8852E",
    pale: "#FFF0DB",
    steps: [
      {
        title: "Go to Users",
        description: "Click Users in the sidebar (admin only). You'll see a list of all people with access to your school's ShrewCare account.",
        tip: "Only admins can invite new users."
      },
      {
        title: "Send an invitation",
        description: "Click 'Invite User'. Enter the person's name, email address, and select their role — Admin, Teacher, or Viewer. For teachers, you can also assign them to a specific classroom.",
        tip: "Admins have full access. Teachers can only see their classroom's data. Viewers have read-only access."
      },
      {
        title: "Staff accepts the invitation",
        description: "The invited person receives a branded email from noreply@shrewcare.com. They click 'Accept Invitation', set their password, and are immediately added to your school.",
        tip: "Invitations expire after 7 days. You can re-send an invite from the Users page if needed."
      },
      {
        title: "Manage roles and access",
        description: "From the Users page, you can change a user's role, reassign their classroom, or remove them from the school at any time. Changes take effect immediately.",
        tip: "Remove staff members as soon as they leave your organization to maintain security."
      }
    ]
  },
  {
    id: "users",
    title: "Users & Roles",
    subtitle: "Manage who has access to your school",
    color: "#E8679A",
    pale: "#FCE4EC",
    steps: [
      {
        title: "Understanding roles",
        description: "ShrewCare has four roles: Admin (full access), Teacher (classroom-level access), Parent (their child's data only), and Viewer (read-only access to everything). Roles determine exactly what each person can see and do.",
        tip: "Only assign Admin role to people who truly need full control — like directors or office managers."
      },
      {
        title: "View all users",
        description: "Go to Users in the sidebar. You'll see everyone with access to your school — admins, teachers, parents, and viewers — with their role, status, and last login date.",
        tip: "Regularly review this list to make sure only current staff and active families have access."
      },
      {
        title: "Change a user's role",
        description: "Click on any user to open their profile. Use the Role dropdown to change their access level. For teachers, you can also change their assigned classroom here. Changes take effect immediately.",
        tip: "Changing a teacher's classroom assignment here also updates it in the Teachers page — they're linked."
      },
      {
        title: "Remove a user",
        description: "To remove someone's access, open their profile and click Remove User. They will immediately lose access to the school's data. Their account still exists — they just can't access your school anymore.",
        tip: "Always remove users promptly when staff leave or parents withdraw their child. This is important for data security."
      }
    ]
  },
  {
    id: "enrollment",
    title: "Enrollment",
    subtitle: "Manage your enrollment pipeline",
    color: "#2E9E6B",
    pale: "#D1FAE5",
    steps: [
      {
        title: "Understanding the pipeline",
        description: "The Enrollment page uses a kanban-style pipeline with stages: Inquiry, Waitlist, Applied, Accepted, Enrolled, and Withdrawn. Each prospective or current student moves through these stages as their enrollment progresses.",
        tip: "Use Inquiry for families who have expressed interest but haven't formally applied yet."
      },
      {
        title: "Add an enrollment application",
        description: "Click 'Add Application' to create a new enrollment record. Enter the child's name, date of birth, desired classroom, and guardian contact details. Assign them an initial stage in the pipeline.",
        tip: "You can create enrollment applications for prospective students before they're formally added to the Students page."
      },
      {
        title: "Move students through stages",
        description: "Click on any enrollment card and use the Stage dropdown to move them forward or backward in the pipeline. Add notes to document any conversations or decisions made at each stage.",
        tip: "When a student reaches Enrolled status, you can promote them directly to the Students page with one click."
      },
      {
        title: "Track your capacity",
        description: "The Enrollment page shows how many students are in each classroom versus the classroom capacity. This helps you manage waitlists and know when you have openings.",
        tip: "Cross-reference the Enrollment pipeline with the Classrooms page to avoid over-enrolling any room."
      }
    ]
  },
  {
    id: "attendance",
    title: "Taking Attendance",
    subtitle: "Track who's in and who's out every day",
    color: "#3B82C4",
    pale: "#DBEAFE",
    steps: [
      {
        title: "Open the Attendance page",
        description: "Click Attendance in the sidebar. Today's date is selected by default. You'll see all enrolled students grouped by classroom.",
        tip: "Attendance is pre-set to 'Present' for all students. You only need to mark exceptions."
      },
      {
        title: "Mark absences and tardiness",
        description: "Click on a student's status badge to change it. Options include Present, Absent (Excused), Absent (Unexcused), and Late. For absences, you can add a reason such as illness, vacation, or family emergency.",
        tip: "Parents are notified through the parent portal when their child is marked absent or late."
      },
      {
        title: "Record teacher attendance",
        description: "Scroll down to the Teacher Attendance section on the same page. Mark teachers as Present, Called Out, or On Leave. Called-out teachers will automatically appear in the Coverage page.",
        tip: "Mark teacher attendance early in the morning so you can arrange coverage before the day begins."
      },
      {
        title: "View past attendance",
        description: "Use the date picker at the top of the Attendance page to navigate to any past date. Attendance records are stored indefinitely and can be exported from the Reports page.",
        tip: "You can edit past attendance records if a mistake was made."
      }
    ]
  },
  {
    id: "coverage",
    title: "Coverage",
    subtitle: "Handle callouts and assign substitute teachers",
    color: "#BF5B21",
    pale: "#FAEBD7",
    steps: [
      {
        title: "How coverage works",
        description: "When a teacher is marked as Called Out on the Attendance page, they automatically appear in the Coverage page. The system shows which classrooms are affected and which substitutes are available.",
        tip: "Mark teacher attendance early in the morning so you have time to arrange coverage before the day starts."
      },
      {
        title: "Assign a substitute",
        description: "Go to Coverage in the sidebar. You'll see a list of called-out teachers and their classrooms. Click 'Assign Sub' next to a classroom to select an available substitute from your roster.",
        tip: "Only teachers marked as substitutes appear in the substitute list. Make sure your subs are set up in the Teachers page."
      },
      {
        title: "View daily assignments",
        description: "The Coverage page shows today's full assignment board — which subs are covering which rooms. You can reassign or remove assignments at any time during the day.",
        tip: "Assignments are date-specific. Yesterday's coverage plan doesn't carry over to today."
      },
      {
        title: "Dashboard alerts",
        description: "If any classrooms are uncovered (a teacher called out but no sub assigned), the dashboard shows a red alert banner with the number of rooms needing coverage. Click it to go directly to the Coverage page.",
        tip: "The dashboard alert disappears once all affected classrooms have a substitute assigned."
      }
    ]
  },
  {
    id: "daily-logs",
    title: "Daily Logs",
    subtitle: "Record activities and share them with parents",
    color: "#9C27B0",
    pale: "#F3E5F5",
    steps: [
      {
        title: "Open the Daily Log page",
        description: "Click Daily Log in the sidebar. Select the classroom and date you want to log. You'll see a list of all students in that room.",
        tip: "Teachers can only see and log activities for students in their assigned classroom."
      },
      {
        title: "Log activities for a student",
        description: "Click on a student's name to expand their log. You can record meals (breakfast, lunch, snack), nap times, diaper changes, learning activities, mood, milestones, and any notes.",
        tip: "The more detail you add, the more parents appreciate it — especially for infants and toddlers."
      },
      {
        title: "Add a note or milestone",
        description: "Use the Note activity type for free-form observations. Use Milestone to record special achievements like first steps, first words, or a drawing they made. These are visible to parents in the portal.",
        tip: "Milestones are highlighted in the parent portal and make for great keepsake moments."
      },
      {
        title: "Parents view the log",
        description: "Everything you log is immediately visible to the student's guardians in the Parent Portal. Parents can see all activities for the current day and scroll through past days.",
        tip: "No need to send a separate daily report — it's all automatic."
      }
    ]
  },
  {
    id: "events",
    title: "Events",
    subtitle: "Schedule and manage school events",
    color: "#9C27B0",
    pale: "#F3E5F5",
    steps: [
      {
        title: "Create an event",
        description: "Go to Events in the sidebar and click 'Add Event'. Enter a title, date, time, location, and description. You can also set an event type — School Event, Holiday, Meeting, or Field Trip.",
        tip: "Events appear in the parent portal so families can stay informed about upcoming activities."
      },
      {
        title: "Edit or delete an event",
        description: "Click on any event in the calendar or list view to open it. From there you can edit any details or delete the event entirely. Changes are reflected immediately in the parent portal.",
        tip: "Use the description field to include any important details parents or staff need to know, like what to bring or dress code."
      },
      {
        title: "Upcoming events on the dashboard",
        description: "Events within the next 3 days appear as notifications in the dashboard. Admins and teachers see a reminder badge on the bell icon so nothing slips through the cracks.",
        tip: "Add events as early as possible so parents have time to prepare — especially for field trips and special dress days."
      },
      {
        title: "Switch between views",
        description: "The Events page has both a calendar view and a list view. Use the calendar for a monthly overview and the list view to quickly scan upcoming events in chronological order.",
        tip: "You can export your events list from the Reports page if you need to share it externally."
      }
    ]
  },
  {
    id: "messages-tickets",
    title: "Messages & Tickets",
    subtitle: "Communicate and resolve issues efficiently",
    color: "#2E9E6B",
    pale: "#D1FAE5",
    steps: [
      {
        title: "Send a direct message",
        description: "Go to Messages in the sidebar. Click the compose icon or select an existing contact to start a conversation. All staff, teachers, and parents in your school are available as contacts.",
        tip: "Messages are real-time — recipients see new messages immediately when they're logged in."
      },
      {
        title: "Use classroom channels",
        description: "Classroom channels allow you to send announcements to all parents in a specific classroom at once. Click on a channel name in the left sidebar of the Messages page to post to it.",
        tip: "Great for reminders about upcoming events, theme days, or supply requests."
      },
      {
        title: "Create a ticket",
        description: "Go to Tickets and click 'New Ticket'. Enter a title, description, priority level (Low, Medium, High, Urgent), and optionally assign it to a staff member. Tickets are used to track issues, maintenance requests, or follow-up tasks.",
        tip: "Use High or Urgent priority sparingly so important tickets stand out."
      },
      {
        title: "Resolve and close tickets",
        description: "Open a ticket and update its status as work progresses — Open, In Progress, Resolved. Add comments to document what was done. Once resolved, the ticket is archived but remains searchable.",
        tip: "Keeping tickets updated helps the whole team stay on the same page without extra meetings."
      }
    ]
  },
  {
    id: "parent-portal",
    title: "Parent Portal",
    subtitle: "Keep families connected and informed",
    color: "#E8679A",
    pale: "#FCE4EC",
    steps: [
      {
        title: "Invite parents",
        description: "Go to Users and click 'Invite User'. Select the Parent role and enter the guardian's name and email. They'll receive an invitation email to set up their account.",
        tip: "Make sure the guardian's email in the student record matches the email you invite them with."
      },
      {
        title: "Link parents to students",
        description: "After a parent accepts their invitation, go to their profile in Users and link them to their child or children. Once linked, they can see their child's data in the portal.",
        tip: "One parent account can be linked to multiple children — useful for families with more than one enrolled child."
      },
      {
        title: "What parents can see",
        description: "Parents can view their child's attendance status, daily activity log, upcoming events, messages from teachers, and billing information. They cannot see other students' data.",
        tip: "Parents access the portal at the same URL — shrewcare.com — and are automatically directed to the parent view after logging in."
      },
      {
        title: "Messaging parents",
        description: "Go to Messages and select a parent or guardian to start a direct conversation. You can also post announcements to an entire classroom channel that all parents in that room can see.",
        tip: "Use classroom channels for general updates and direct messages for private conversations about individual students."
      }
    ]
  },
  {
    id: "billing",
    title: "Billing & Tuition",
    subtitle: "Set up tuition plans, generate invoices, and track payments",
    color: "#BF5B21",
    pale: "#FAEBD7",
    steps: [
      {
        title: "Understanding how billing works",
        description: "ShrewCare billing has two parts: Tuition Plans and Invoices. Think of a Tuition Plan as a price list — you set up what each type of enrollment costs (e.g. 'Infant Full-Time: $1,800/month'). Then each month, you generate Invoices from those plans, one per student. Invoices are what families actually owe and pay.",
        tip: "Set up your Tuition Plans first before adding students — that way you can assign a plan to each student or classroom right away."
      },
      {
        title: "Create a tuition plan",
        description: "Go to Billing in the sidebar and click the 'Tuition Plans' tab. Click 'Add Plan' and fill in the plan name (e.g. 'Toddler Full-Time'), the monthly rate, and optionally a registration fee, sibling discount percentage, and staff discount percentage. Click Save.",
        tip: "You can create as many plans as you need — one per classroom type is the most common setup."
      },
      {
        title: "Assign a tuition plan to students",
        description: "There are two ways to assign plans. Option 1: assign a plan to a whole classroom (go to Classrooms, edit the room, and select a tuition plan — all students in that room inherit it). Option 2: assign a plan directly to an individual student in their student profile for exceptions like part-time schedules.",
        tip: "Student-level plans override classroom-level plans. Use this for students with special arrangements."
      },
      {
        title: "Generate monthly invoices",
        description: "On the first of each month, go to Billing → Invoices tab and click 'Generate Monthly Invoices'. ShrewCare will preview how many invoices will be created and for which students. Confirm and they're created instantly — one invoice per enrolled student based on their tuition plan.",
        tip: "Always preview before confirming — the preview shows you exactly what will be generated so there are no surprises."
      },
      {
        title: "Create a single invoice manually",
        description: "For one-off charges like registration fees, field trip costs, or late fees, click 'New Invoice'. Select the student, enter the amount, due date, and a description. You can also add a late fee if the invoice is overdue.",
        tip: "Use the description field clearly — parents see this on their invoice in the Parent Portal."
      },
      {
        title: "Mark invoices as paid",
        description: "When a family pays, find their invoice in the Invoices tab and click on it. Change the status to 'Paid', enter the amount paid, payment date, and payment method (cash, check, card, or bank transfer). Click Save.",
        tip: "You can select multiple invoices at once and bulk mark them as paid — great for processing a batch of payments at the start of the month."
      },
      {
        title: "What parents see",
        description: "Parents can view all their invoices in the Parent Portal under 'My Billing'. They can see the amount due, due date, status (pending or paid), and payment history. They cannot pay directly through ShrewCare yet — payment is collected outside the app and recorded by you.",
        tip: "Coming soon: Stripe Connect will allow parents to pay tuition directly through the portal."
      },
      {
        title: "Track overdue invoices",
        description: "The Invoices tab shows all invoices with color-coded status badges — green for paid, yellow for pending, red for overdue. You can filter by status to quickly see who hasn't paid. Use the export button to download the full list for your records.",
        tip: "Run a quick overdue check at the start of each month before generating new invoices."
      }
    ]
  },
  {
    id: "reports",
    title: "Reports",
    subtitle: "Generate insights and export your data",
    color: "#E8852E",
    pale: "#FFF0DB",
    steps: [
      {
        title: "What reports are available",
        description: "The Reports page provides summaries for attendance trends, student enrollment by classroom, teacher attendance patterns, ticket volume, and daily activity log summaries. Charts update automatically based on your real data.",
        tip: "Reports cover the current school year by default. Use the date filters to narrow down to a specific period."
      },
      {
        title: "Attendance report",
        description: "The attendance report shows present/absent/late rates by student and by classroom over any date range. You can identify patterns — like a student who is frequently absent on Mondays — at a glance.",
        tip: "High absence rates are automatically flagged with a warning color so problem areas are immediately visible."
      },
      {
        title: "Export data to CSV or Excel",
        description: "Most reports have an Export button at the top right. Click it to download the data as a CSV or Excel file. This is useful for sharing with parents, directors, or licensing agencies.",
        tip: "Excel exports include formatting and column headers that make them easy to share professionally."
      },
      {
        title: "Student and classroom drill-down",
        description: "Click on any student's name in a report to jump directly to their profile in the Students page. Click on a classroom name to go to that classroom's detail view.",
        tip: "Use reports at the end of each month to review trends and identify students who may need extra attention."
      }
    ]
  },
  {
    id: "audit",
    title: "Audit Log",
    subtitle: "Track all changes for accountability",
    color: "#475569",
    pale: "#F1F5F9",
    steps: [
      {
        title: "What is the Audit Log",
        description: "The Audit Log is a complete, tamper-proof record of every significant action taken in your ShrewCare account — logins, data changes, student additions, settings updates, and more. It is accessible only to admins.",
        tip: "The Audit Log cannot be edited or deleted. It is a permanent record designed for accountability and compliance."
      },
      {
        title: "Reading audit entries",
        description: "Each entry shows the date and time, the user who performed the action, and a description of what changed. Entries are shown in reverse chronological order — newest first.",
        tip: "Look for the username in each entry to understand who made a particular change."
      },
      {
        title: "Filtering the log",
        description: "Use the search bar at the top of the Audit Log to filter entries by keyword, user, or action type. This helps you quickly find specific events — for example, all changes made by a particular staff member.",
        tip: "Search for 'Login' to see a history of all user sign-ins to your account."
      },
      {
        title: "Using the log for compliance",
        description: "If your school is subject to licensing or regulatory requirements, the Audit Log provides documentation of data access and changes. You can screenshot or export entries as needed for compliance audits.",
        tip: "Make it a habit to review the Audit Log periodically — especially after any staff changes or unusual activity."
      }
    ]
  },
  {
    id: "school-year",
    title: "School Years",
    subtitle: "Manage your academic calendar and year-end rollover",
    color: "#3B82C4",
    pale: "#DBEAFE",
    steps: [
      {
        title: "What is a school year?",
        description: "ShrewCare organizes all your data — students, attendance, daily logs, invoices, and more — within a school year. This keeps your records clean and separate. For example, '2024-2025' and '2025-2026' are two separate years, each with their own data.",
        tip: "You always work in the active year. Archived years are read-only — you can view them but not edit them."
      },
      {
        title: "Create a new school year",
        description: "In the sidebar, click the school year selector (usually shown near the top or bottom of the sidebar). Click 'New School Year' and enter the year name (e.g. '2025-2026'). When you create a new year, your classrooms and teachers carry over automatically — you don't have to re-enter them.",
        tip: "Create the new school year a few weeks before it starts so you can set up classrooms and enroll students in advance."
      },
      {
        title: "What carries over to the new year",
        description: "When you create a new school year, classrooms and teachers are automatically copied over. Students do NOT carry over automatically — this is intentional, since enrollment changes each year. Use the Import Students feature in the Students page to bring returning students over from the previous year.",
        tip: "Review your classroom list before importing students — you may want to rename or restructure rooms for the new year first."
      },
      {
        title: "Archive the current year",
        description: "When the school year ends, the current year is automatically archived when you create the new one. You can also manually archive a year from the school year selector. Archived years are safely stored and can be viewed at any time for reference or reporting.",
        tip: "Run any reports you need from the old year before archiving — especially attendance summaries and billing history."
      },
      {
        title: "Switch between years",
        description: "You can view archived school years at any time by selecting them from the school year selector in the sidebar. All data for that year — attendance, students, logs, invoices — is preserved exactly as it was. Switch back to the active year when you're done.",
        tip: "Archived years are great for reference during parent meetings or if a licensing authority requests historical records."
      },
      {
        title: "Roll students over to the new year",
        description: "After creating your new school year, go to the Students page and click 'Import from Previous Year'. A window will open where you select which previous year to pull from. You'll see a full list of all students from that year along with their old classroom.",
        tip: "Make sure your new classrooms are already set up before importing — you'll need to assign each imported student to a room."
      },
      {
        title: "Selecting which students to import",
        description: "In the import window, choose the source year from the dropdown. Then use 'Select All' to grab everyone, or check individual students to pick and choose. Students who are not returning — withdrawn, graduated, or aged out — should be left unchecked.",
        tip: "You can see each student's old classroom and date of birth in the list to help you decide who to bring over."
      },
      {
        title: "Assigning students to their new classroom",
        description: "Before confirming the import, select the target classroom from the 'Import Into Classroom' dropdown. All selected students will be placed into that classroom. If students are going into different classrooms, run the import multiple times — once per classroom, selecting the relevant students each time.",
        tip: "For example: first import the students moving to Butterflies, then run the import again for students moving to Sunflowers."
      },
      {
        title: "After the import",
        description: "Imported students appear in your Students page with a fresh enrollment date and no withdrawal date. Their name, date of birth, and guardian information carry over automatically — you don't need to re-enter any of that. Review each student's profile to make sure their tuition plan is correctly assigned for the new year.",
        tip: "Attendance history and daily logs stay in the old year — the imported students start fresh with a clean slate in the new year."
      }
    ]
  },
  {
    id: "subscription",
    title: "Your ShrewCare Subscription",
    subtitle: "Manage your plan, billing, and account",
    color: "#2E9E6B",
    pale: "#D1FAE5",
    steps: [
      {
        title: "View your subscription status",
        description: "Go to Settings (gear icon in the sidebar) and click the Subscription tab. You'll see whether you're in your free trial or on a paid plan, your next billing date, and how many days remain in your trial.",
        tip: "Your 30-day free trial starts the day you sign up. A valid credit card is required but you won't be charged until the trial ends."
      },
      {
        title: "What's included in your plan",
        description: "ShrewCare has one plan — SMP Pro at $19/month. It includes everything: unlimited classrooms and students, all features, all pages, and access for your entire team. There are no per-user fees or feature upgrades to worry about.",
        tip: "You can invite as many admins, teachers, and parents as your school needs — at no extra cost."
      },
      {
        title: "Update your payment method",
        description: "Click 'Manage Subscription' in the Subscription tab. This opens the Stripe customer portal — a secure page managed by Stripe where you can update your credit card, view your billing history, and download past invoices.",
        tip: "ShrewCare never stores your card number. All payment details are handled securely by Stripe."
      },
      {
        title: "What happens if payment fails",
        description: "If a payment fails, Stripe will retry automatically over several days and send you reminder emails. During this time you'll still have access. If payment continues to fail, access will be suspended until the billing issue is resolved.",
        tip: "Keep your card details up to date to avoid any interruption to your school's access."
      },
      {
        title: "Cancel your subscription",
        description: "To cancel, go to Settings → Subscription → Manage Subscription. In the Stripe portal, click 'Cancel plan'. Your access continues until the end of the current billing period — you won't be cut off immediately. Your data is retained for 30 days after cancellation.",
        tip: "We're sorry to see you go! If you're cancelling due to a specific issue, reach out to support@shrewcare.com first — we may be able to help."
      }
    ]
  }
];

const TutorialGuide = ({ onBack, userRole }) => {
  const [activeTopic, setActiveTopic] = useState(null);
  const [activeStep, setActiveStep] = useState(0);

  // Parent-relevant topics only
  const PARENT_TOPICS = ["parent-portal", "messages-tickets", "billing"];
  const visibleTopics = userRole === "parent"
    ? TOPICS.filter(t => PARENT_TOPICS.includes(t.id))
    : userRole === "teacher"
    ? TOPICS.filter(t => !["school-setup", "users", "enrollment", "billing", "reports", "audit", "school-year", "subscription"].includes(t.id))
    : TOPICS;

  const topic = visibleTopics.find(t => t.id === activeTopic) || null;

  const handleTopicSelect = (id) => {
    setActiveTopic(id);
    setActiveStep(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = () => {
    if (activeTopic) {
      setActiveTopic(null);
      setActiveStep(0);
    } else {
      onBack();
    }
  };

  // Safety guard — if topic not found, reset
  if (activeTopic && !topic) {
    setActiveTopic(null);
    return null;
  }

  return (
    <div style={{ fontFamily: "'DM Sans', -apple-system, sans-serif", background: "#FDF6F9", minHeight: "100vh", color: "#2D1B28" }}>
      <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@700;800;900&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />

      {/* Nav */}
      <nav style={{ position: "sticky", top: 0, background: "rgba(253,246,249,0.95)", backdropFilter: "blur(12px)", borderBottom: "1px solid #F0DDE8", padding: "0 5%", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between", zIndex: 10 }}>
        <div style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: 18, color: "#4A2040", display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg, #E8679A, #F48FB1)", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: 900, fontSize: 14 }}>S</div>
          ShrewCare
          {activeTopic && <span style={{ color: "#9E7A90", fontWeight: 600, fontSize: 14, marginLeft: 8 }}>/ Getting Started</span>}
        </div>
        <button onClick={handleBack} style={{ background: "none", border: "1px solid #F0DDE8", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 600, color: "#8E6C88", cursor: "pointer", fontFamily: "inherit" }}>
          ← {activeTopic ? "All Topics" : "Back"}
        </button>
      </nav>

      {!activeTopic ? (
        // TOPIC SELECTION
        <div style={{ maxWidth: 900, margin: "0 auto", padding: "56px 5% 100px" }}>
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <div style={{ display: "inline-block", fontSize: 12, fontWeight: 800, letterSpacing: "1.5px", textTransform: "uppercase", color: "#E8679A", marginBottom: 12 }}>Getting Started</div>
            <h1 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: "clamp(32px, 5vw, 48px)", color: "#4A2040", marginBottom: 16, lineHeight: 1.1 }}>ShrewCare Tutorial Guide</h1>
            <p style={{ fontSize: 17, color: "#9E7A90", maxWidth: 520, margin: "0 auto", lineHeight: 1.7 }}>Everything you need to know to get your school up and running. Click any topic below to get started.</p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 20 }}>
            {visibleTopics.map((t, i) => (
              <button
                key={t.id}
                onClick={() => handleTopicSelect(t.id)}
                style={{ background: "white", border: `1px solid #F0DDE8`, borderRadius: 20, padding: 28, textAlign: "left", cursor: "pointer", fontFamily: "inherit", transition: "all 0.2s", display: "flex", flexDirection: "column", gap: 12 }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(74,32,64,0.08)"; e.currentTarget.style.borderColor = t.color; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; e.currentTarget.style.borderColor = "#F0DDE8"; }}
              >
                <div style={{ width: 48, height: 48, borderRadius: 14, background: t.pale, display: "flex", alignItems: "center", justifyContent: "center", color: t.color }}>{getIcon(t.id)}</div>
                <div>
                  <div style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 16, color: "#4A2040", marginBottom: 4 }}>{t.title}</div>
                  <div style={{ fontSize: 13, color: "#9E7A90", lineHeight: 1.5 }}>{t.subtitle}</div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
                  {t.steps.map((_, si) => (
                    <div key={si} style={{ width: 6, height: 6, borderRadius: "50%", background: t.color, opacity: 0.3 }} />
                  ))}
                  <span style={{ fontSize: 12, color: "#9E7A90", marginLeft: 4 }}>{t.steps.length} steps</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      ) : (
        // STEP-BY-STEP VIEW
        <div style={{ maxWidth: 800, margin: "0 auto", padding: "48px 5% 100px" }}>
          {/* Topic header */}
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 40 }}>
            <div style={{ width: 56, height: 56, borderRadius: 16, background: topic.pale, display: "flex", alignItems: "center", justifyContent: "center", color: topic.color, flexShrink: 0 }}>{getIcon(activeTopic)}</div>
            <div>
              <h1 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: 28, color: "#4A2040", margin: 0, lineHeight: 1.1 }}>{topic.title}</h1>
              <p style={{ fontSize: 15, color: "#9E7A90", margin: "6px 0 0" }}>{topic.subtitle}</p>
            </div>
          </div>

          {/* Progress bar */}
          <div style={{ marginBottom: 36 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: "#9E7A90" }}>Step {activeStep + 1} of {topic.steps.length}</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: topic.color }}>{Math.round(((activeStep + 1) / topic.steps.length) * 100)}% complete</span>
            </div>
            <div style={{ height: 6, background: "#F0DDE8", borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${((activeStep + 1) / topic.steps.length) * 100}%`, background: topic.color, borderRadius: 3, transition: "width 0.4s ease" }} />
            </div>
          </div>

          {/* Step tabs */}
          <div style={{ display: "flex", gap: 8, marginBottom: 32, flexWrap: "wrap" }}>
            {topic.steps.map((step, i) => (
              <button
                key={i}
                onClick={() => setActiveStep(i)}
                style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px", borderRadius: 100, border: `2px solid ${i === activeStep ? topic.color : i < activeStep ? topic.color + "66" : "#F0DDE8"}`, background: i === activeStep ? topic.pale : i < activeStep ? topic.color + "11" : "white", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 700, color: i === activeStep ? topic.color : i < activeStep ? topic.color : "#9E7A90", transition: "all 0.2s" }}
              >
                <div style={{ width: 20, height: 20, borderRadius: "50%", background: i <= activeStep ? topic.color : "#F0DDE8", color: "white", fontSize: 11, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  {i < activeStep ? "✓" : i + 1}
                </div>
                <span style={{ whiteSpace: "nowrap" }}>{step.title}</span>
              </button>
            ))}
          </div>

          {/* Active step card */}
          <div style={{ background: "white", borderRadius: 24, border: `2px solid ${topic.color}33`, padding: 40, marginBottom: 24, boxShadow: `0 8px 32px ${topic.color}12` }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
              <div style={{ width: 40, height: 40, borderRadius: 12, background: topic.color, color: "white", fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{activeStep + 1}</div>
              <h2 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 22, color: "#4A2040", margin: 0 }}>{topic.steps[activeStep].title}</h2>
            </div>
            <p style={{ fontSize: 16, lineHeight: 1.8, color: "#3D2A34", marginBottom: 24 }}>{topic.steps[activeStep].description}</p>
            {topic.steps[activeStep].tip && (
              <div style={{ display: "flex", gap: 12, padding: "16px 20px", background: topic.pale, borderRadius: 12, borderLeft: `4px solid ${topic.color}` }}>
                <svg width="18" height="18" viewBox="0 0 256 256" fill={topic.color} style={{ flexShrink: 0, marginTop: 2 }}><path d="M176 232a8 8 0 0 1-8 8H88a8 8 0 0 1 0-16h80a8 8 0 0 1 8 8zm40-128a87.55 87.55 0 0 1-33.64 69.21A16.24 16.24 0 0 0 176 186v6a16 16 0 0 1-16 16H96a16 16 0 0 1-16-16v-6a16 16 0 0 0-6.23-12.66A87.59 87.59 0 0 1 40 104a88 88 0 0 1 176 0zm-16 0a72 72 0 1 0-72 72 72.08 72.08 0 0 0 72-72z"/></svg>
                <p style={{ fontSize: 14, color: "#4A2040", margin: 0, lineHeight: 1.6 }}><strong>Tip:</strong> {topic.steps[activeStep].tip}</p>
              </div>
            )}
          </div>

          {/* Navigation buttons */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <button
              onClick={() => setActiveStep(s => Math.max(0, s - 1))}
              disabled={activeStep === 0}
              style={{ padding: "12px 28px", borderRadius: 12, border: "2px solid #F0DDE8", background: "white", color: activeStep === 0 ? "#C5B0BC" : "#4A2040", fontFamily: "inherit", fontSize: 14, fontWeight: 700, cursor: activeStep === 0 ? "not-allowed" : "pointer", transition: "all 0.2s" }}
            >
              ← Previous
            </button>

            {activeStep < topic.steps.length - 1 ? (
              <button
                onClick={() => setActiveStep(s => s + 1)}
                style={{ padding: "12px 28px", borderRadius: 12, border: "none", background: topic.color, color: "white", fontFamily: "inherit", fontSize: 14, fontWeight: 700, cursor: "pointer", boxShadow: `0 4px 16px ${topic.color}44`, transition: "all 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-1px)"}
                onMouseLeave={e => e.currentTarget.style.transform = ""}
              >
                Next Step →
              </button>
            ) : (
              <button
                onClick={() => setActiveTopic(null)}
                style={{ padding: "12px 28px", borderRadius: 12, border: "none", background: "#66BB6A", color: "white", fontFamily: "inherit", fontSize: 14, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 16px rgba(102,187,106,0.4)", transition: "all 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-1px)"}
                onMouseLeave={e => e.currentTarget.style.transform = ""}
              >
                ✓ Done — Back to Topics
              </button>
            )}
          </div>

          {/* Other topics */}
          <div style={{ marginTop: 56 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#9E7A90", textTransform: "uppercase", letterSpacing: "1px", marginBottom: 16 }}>Other Topics</div>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {visibleTopics.filter(t => t && t.id !== activeTopic).map(t => (
                <button
                  key={t.id}
                  onClick={() => handleTopicSelect(t.id)}
                  style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 16px", borderRadius: 100, border: "1px solid #F0DDE8", background: "white", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600, color: "#4A2040", transition: "all 0.2s" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = t.color; e.currentTarget.style.color = t.color; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = "#F0DDE8"; e.currentTarget.style.color = "#4A2040"; }}
                >
                  <span style={{ color: t.color, display: "flex" }}>{getIcon(t.id)}</span> {t.title}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TutorialGuide;
